module.exports = __webpack_public_path__ + "static/media/thoitrangdetail.f215b7f1.jpg";